<template>
  <div id="app" v-loading="!finish && $route.meta.login" :class="`common-body-style ${$route.meta.ishome ? 'home-bg' : ''} `">
    <div>
      <v-nav v-if="!$route.meta.login && finish && isFullscreen"> </v-nav>
    </div>
    <!-- -->
    <!-- <v-nav
      v-if="
      finish &&((!$route.meta.login && !($store.state.user.userInfo.natureId==2 )) ||
        (!$route.meta.login && !$route.meta.ishome))

      "
    >
    </v-nav> -->

    <keep-alive>
      <router-view class="loading-area" v-if="$route.meta.keepAlive && isRouterAlive" />
    </keep-alive>
    <router-view class="loading-area" v-if="!$route.meta.keepAlive && isRouterAlive" />

    <alarm v-if="!$route.meta.login && finish && !$route.meta.newHome && !$route.meta.editName && !$route.meta.unit" />
  </div>
</template>

<script>
import vNav from '@/components/vNav.vue';
import alarm from '@/components/alarm.vue';
import { getMap, getWeihu } from './api/common';
import lwnav from '@/components/Lwnav.vue';
import { Settings } from './layout/components';
export default {
  provide() {
    return {
      reload: this.reload, //提供数据
    };
  },
  data() {
    return {
      isRouterAlive: true,
      finish: false,
      isFullscreen: true, // 全屏
    };
  },
  components: {
    lwnav,
    vNav,
    alarm,
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
        console.log('确实刷新了');
      });
    },
  },
  created() {
    //getMap()
    // getWeihu().then((res) => {
    //   this.$store.commit("isWeihu", res.data);
    //   var obj = this.$store.state.weihutime;
    //   if (obj.endtime && obj.starttime) {
    //     this.$alert(
    //       `尊敬的客户,我们将于 ${obj.starttime} 至 ${obj.endtime} 进行系统升级维护，维护期间系统暂时无法登入，给您造成不便，敬请谅解。`,
    //       "公告",
    //       {
    //         confirmButtonText: "确定",
    //       }
    //     );
    //   }
    // });
  },
  mounted() {
    // 监听窗口变动 隐藏显示nav栏
    void ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange'].forEach((item) => {
      window.addEventListener(item, () => {
        console.log('窗口变化');
        this.isFullscreen = !this.isFullscreen;
      });
    });
    setTimeout(() => {
      this.finish = true;
    }, 1000);
    // const favicon = document.querySelector("link[rel*='icon']")
    const favicon = document.getElementById('title');
    // favicon.innerText = "21312";
    // console.log(favicon);
  },
};
</script>

<style lang="scss">
/* 改变主题色变量 */

@import './assets/css/app.css';
@import './assets/font-tr/style.css';
@import './assets/font-awesome/css/font-awesome.min.css';
@import './assets/weather-icons/css/weather-icons.min.css';
@import './assets/weather-icons/css/weather-icons-wind.css';
@import 'assets/css/main.scss';
.cascader-popper {
 .el-cascader-node {
 position: relative;
}
.el-radio{
 width: 130px !important;
 height: 34px !important;
 z-index: 10;
 position: absolute;
 }
 .el-radio__input {
  visibility: hidden;
 }
}
</style>
